<script>
	// The params prop contains values matched from the URL
	export let params = {};

	import { createEventDispatcher } from 'svelte';
	import { replace } from 'svelte-spa-router';
	import { 
		gerarStringAleatoria, 
		TipoEvento, 
		API,
		cabecalhoPadraoRequisicao,
		StatusHttp, 
		TextoFeedback } from '../../utils';
	import { sCaptcha } from '../../stores';
	import TBox from '../templates/TBox.svelte';
	import Captcha from '../../componentes/Captcha.svelte';

	const dispatch = createEventDispatcher();
	
	// variáveis para trabalhar com os dados do formulário
	let valor, captchaUsuario;
	let tituloAviso = "Erro";

	async function submeterFormulario(event) {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Alterando valor ...',
		});
			
		if (captchaUsuario != $sCaptcha) {
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Captcha Inválido',
				conteudo: 'O código informado é inválido, tente novamente.'
			});
			
			// atualiza o store
			sCaptcha.update(novaString => gerarStringAleatoria());
		} else {
			if (params.escopo == 'LOCAL') {
				localStorage.setItem(params.variavel, valor);

				// aguarda 1seg pq o replace/push as não é síncrono com localStorage, pode encaminhar antes do localStorage executar
				setTimeout(() => replace('#/painel/configuracoes'), 1000);

				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: 'Tudo certo!',
					conteudo: 'Variável local atualizada'
				});
			} else {
				// faz a chamada a API no endpoint atualizar, envia os dados e aguarda a resposta
				const resposta = await fetch(API('configuracoes'), {
					method: 'PATCH',
					headers: cabecalhoPadraoRequisicao(),
					body: JSON.stringify({
						tipo: params.variavel,
						valor: valor
					})
				}).catch(erros => {
					dispatch('routeEvent', { 
						tipo: TipoEvento.ESTA_CARREGANDO,
						valor: false
					});
					
					dispatch('routeEvent', {
						tipo: TipoEvento.ABRIR_MODAL,
						titulo: tituloAviso,
						conteudo: TextoFeedback.ERRO_REQUISICAO
					});
				});
	
				// pro método PATCH o retorno ideal é 204 (no-content) mas a API pode retornar mensagens úteis, ela envia 200 se a atualização for realizada.
				if (resposta.status == StatusHttp.OK) {
					dispatch('routeEvent', {
						tipo: TipoEvento.ABRIR_MODAL,
						titulo: 'Tudo certo!',
						conteudo: 'Variável global atualizada'
					});

					replace('#/painel/configuracoes');
				} else {
					let json = await resposta.json();

					dispatch('routeEvent', {
						tipo: TipoEvento.ABRIR_MODAL,
						titulo: 'Erro',
						conteudo: json.mensagem
					});
				}
			}
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
	}
</script>

<TBox 
	titulo="Configuração de Variável {params.escopo}" 
	subtitulo="Alteração de valor da variável {params.variavel}" 
	largura="8" 
	deslocamento="2" 
	correcaoY="-13px"
	icone="computador">
	
	<form method="post" on:submit|preventDefault={submeterFormulario}>
		<div class="columns">
			<div class="column is-full">
				<div class="field">
					<input 
						bind:value={valor}
						name="valor" 
						type="text" 
						placeholder="Digite o novo valor aqui" 
						class="input is-large is-primary" required>
				</div>
			</div>
		</div>

		<div class="columns is-mobile">
			<div class="column">
				<Captcha />
			</div>
			<div class="column">
				<input 
					name="captcha"
					bind:value={captchaUsuario}
					type="text"
					maxlength="8" 
					placeholder="Digite o código aqui" 
					class="input is-large is-primary" required>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<p class="control">
					<a href="#/" class="button is-black is-medium is-outlined is-fullwidth">Início</a>
				</p>
			</div>
			<div class="column is-8">
				<p class="control">
					<button 
						type="submit" 
						class="button is-primary is-medium is-fullwidth">
						Atualizar
					</button>
				</p>
			</div>
		</div>
	</form>
</TBox>